import styled from "styled-components";
export const CpatchaContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Canvas = styled.div`
  display: flex;
  margin: 10px 10px 10px 0px;
  height: 43px;
  border: 1px solid;
  border-radius: 10px;
  canvas
  {
    border-radius: 10px;
    cursor: pointer;
  }
`;
